import { render, staticRenderFns } from "./createSpecificRequirements.vue?vue&type=template&id=9ece5e5c&scoped=true&"
import script from "./createSpecificRequirements.vue?vue&type=script&lang=js&"
export * from "./createSpecificRequirements.vue?vue&type=script&lang=js&"
import style0 from "./createSpecificRequirements.vue?vue&type=style&index=0&id=9ece5e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ece5e5c",
  null
  
)

export default component.exports